import {APIClient} from "../../base";

const DashboardV2Api = {
    summary: async () => await APIClient.get("/v2/dashboard", {}),
};

export default DashboardV2Api;
